module.exports = __webpack_public_path__ + "img/menu (2).a128e512.svg";